import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Form, Spinner  } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import {useLazyGetDistributorListQuery } from "../../../State/Api/AddPurchaseApiSlice";


const DistributorSelectModal = ({ show, onHide, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [distributors, setDistributors] = useState([]);

   const [triggerGetDistributors, { isFetching }] = useLazyGetDistributorListQuery();

   useEffect(() => {
    if (!searchTerm.trim()) {
      setDistributors([]);
      return;
    }

    const fetchData = async () => {

   
      try {
        const pharmaId = localStorage.getItem("userUniqueID");
        const response = await triggerGetDistributors({ pharmaId, distributorName: searchTerm }).unwrap();
           console.log("📦 Distributor API Response:", response);

      const list = Array.isArray(response.data) ? response.data : response?.result || [];
setDistributors(list);
      } catch (error) {
        console.error("❌ Error fetching distributors:", error);
        toast.error("Failed to load distributors!", {
          position: "top-center",
          style: { background: "#ef4444", color: "#fff", fontWeight: 500 },
        });
        setDistributors([]);
      }
    };

    const debounce = setTimeout(fetchData, 400);
    return () => clearTimeout(debounce);
  }, [searchTerm, triggerGetDistributors]);

  if (!show) return null;

  return (
    <>
      <style>
        {`
          .dist-footer-bar {
            font-size: 13px;
            color: #679d70ff;
            letter-spacing: 0.7px;
            background: #f8f2fd;
            padding: 13px 24px 13px 28px;
            border-bottom-left-radius: 13px;
            border-bottom-right-radius: 13px;
            border-top: 1.2px solid #f1e8f8;
            margin-top: auto;
          }
          .distributor-highlight-row {
            background: #f0e1f9;
          }
          .distributor-name {
            color: #0fb65aff;
            font-weight: 600;
            font-size: 15px;
          }
          .distributor-address {
            color: #6ba778ff;
            font-size: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 2px;
            display: block;
          }
          .modal-title-secondary {
            color: #767784;
            font-size: 14px;
            margin: 0 0 5px 0;
          }
          .purple-btn {
            background: #45306D !important;
            border: none !important;
            border-radius: 8px !important;
            font-weight: 500;
            font-size: 15px;
            padding: 10px 24px !important;
          }
        .table-header th {
  background-color: #d8dbdbff;
}
        `}
      </style>
      <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
        <Modal.Header style={{ borderBottom: "none", alignItems: "flex-start" }}>
          <div style={{ flex: 1 }}>
            <h5 style={{ fontWeight: 700, marginBottom: 2 }}>Select a Distributor</h5>
            <div className="modal-title-secondary">Search and select a distributor</div>
          </div>
          <Button
            variant="link"
            style={{
              color: "#8e4d90",
              fontSize: 28,
              textDecoration: "none",
              marginTop: -4,
            }}
            onClick={onHide}
          >
            &times;
          </Button>
        </Modal.Header>

        <Modal.Body style={{ paddingTop: 12, paddingBottom: 0 }}>
          <div className="d-flex mb-3" style={{ gap: 22 }}>
            <Form.Group style={{ width: "100%" }}>
              <Form.Label style={{ fontWeight: 500, marginBottom: 3 }}>
                Search Distributor
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Start typing distributor name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  border: "1.7px solid #caddd1ff",
                  borderRadius: "8px",
                  width: "100%",
                  fontSize: "14px",
                }}
                autoFocus
              />
            </Form.Group>
          </div>

          <div style={{ maxHeight: 320, overflowY: "auto" }}>
            {isFetching ? (
              <div className="d-flex justify-content-center align-items-center py-4">
                <Spinner animation="border" variant="secondary" size="sm" />
                <span style={{ marginLeft: 8, fontSize: 13 }}>Loading distributors...</span>
              </div>
            ) : distributors.length > 0 ? (
              <Table hover responsive style={{ width: "100%" }}>
                <thead className="table-header">
                  <tr>
                    <th>Distributor Name / Address</th>
                    <th>Mobile No</th>
                    <th>GSTIN</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {distributors.map((dist, idx) => (
                    <tr
                      key={dist.id || idx}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        onSelect && onSelect(dist);
                        onHide();
                        toast.success("Distributor selected!", {
                          position: "top-center",
                          duration: 1500,
                          style: { background: "#10b981", color: "#fff", fontWeight: 500 },
                        });
                      }}
                    >
                      <td>
                        <div className="distributor-name" style={{ fontWeight: 600 }}>
                          {dist.distributorName}
                        </div>
                        {dist.address && (
                          <span className="distributor-address" style={{ fontSize: 13, color: "#6b7280" }}>
                            {dist.addresses}
                          </span>
                        )}
                      </td>
                      <td>{dist.mobileNum || "-"}</td>
                      <td>{dist.gstNum || "-"}</td>
                      <td>{dist.openBalance || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="text-center text-muted py-3" style={{ fontSize: 13 }}>
                {searchTerm.trim()
                  ? "No distributors found for this search."
                  : "Start typing to search distributors."}
              </p>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Toaster />
    </>
  );
}

export default DistributorSelectModal;
